import React, { useEffect, useState } from "react";
import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import GeofencesMultiInput from "../../Helpers/MultiInput/GeofencesMultiInput";
import NotificationsMultiInput from "../../Helpers/MultiInput/NotificationsMultiInput";
import DriversMultiInput from "../../Helpers/MultiInput/DriversMultiInput";

import {
  useAddPermissionMutation,
  useDeletePermissionMutation,
} from "../../../Redux/service/Permissions/Permissions";
import { toast } from "react-toastify";
import trans from "../../../utils";
import { useGetAllDevicesQuery } from "../../../Redux/service/Devices";
import { useSelector } from "react-redux";
import MaintenanceMultiInput from "../../Helpers/MultiInput/MaintenanceMultiInput";

export default function VehicleConnectionPopup({
  vehicleId,
  name,
  setIsLinking,
  imei,
}) {
  const [uniqueId, setUniqueId] = useState();
  const { data } = useGetAllDevicesQuery();

  useEffect(() => {
    if (data?.length > 0 && imei) {
      let res = data?.find((i) => i.uniqueId === imei);
      setUniqueId(res?.id);
    }
  }, [data, imei]);
  const [addPermission] = useAddPermissionMutation();
  const [deletePermission] = useDeletePermissionMutation();

  const handleLink = async (id, type, name) => {
    await addPermission({
      deviceId: uniqueId,
      [`${type}Id`]: id,
    })
      .unwrap()
      .then(() => {
        if (type === "geofence") {
          toast.success(trans("Geofence is linked to vehicle successfully"), {
            autoClose: 800,
            rtl: localStorage.getItem("lang") === "ar" ? true : false,
          });
        } else if (type === "notification") {
          toast.success(
            trans(`Notification is linked to vehicle successfully`),
            {
              autoClose: 800,
              rtl: localStorage.getItem("lang") === "ar" ? true : false,
            }
          );
        } else if (type === "driver") {
          toast.success(trans(`Driver is linked to vehicle successfully`), {
            autoClose: 800,
            rtl: localStorage.getItem("lang") === "ar" ? true : false,
          });
        } else if (type === "maintenance") {
          toast.success(
            trans(`Maintenance is linked to vehicle successfully`),
            {
              autoClose: 800,
              rtl: localStorage.getItem("lang") === "ar" ? true : false,
            }
          );
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(
          `${trans("Failed to link")} ${trans(type)} ${
            (trans("to vehicle"),
            {
              autoClose: 800,
              rtl: localStorage.getItem("lang") === "ar" ? true : false,
            })
          } `
        );
      });
  };
  const handleUnLink = async (id, type, name) => {
    await deletePermission({
      deviceId: uniqueId,
      [`${type}Id`]: id,
    })
      .unwrap()
      .then(() => {
        if (type === "geofence") {
          toast.success(
            trans(`Geofence is unlinked from vehicle successfully`),
            {
              autoClose: 800,
              rtl: localStorage.getItem("lang") === "ar" ? true : false,
            }
          );
        } else if (type === "notification") {
          toast.success(
            trans(`Notification is unlinked from vehicle successfully`),
            {
              autoClose: 800,
              rtl: localStorage.getItem("lang") === "ar" ? true : false,
            }
          );
        } else if (type === "driver") {
          toast.success(trans(`Driver is unlinked from vehicle successfully`), {
            autoClose: 800,
            rtl: localStorage.getItem("lang") === "ar" ? true : false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(
          `${trans("Failed to unlink")} ${trans(type)} ${trans("to vehicle")} `,
          {
            autoClose: 800,
            rtl: localStorage.getItem("lang") === "ar" ? true : false,
          }
        );
      });
  };
  const inf = useSelector((state) => state.users.user);
  return (
    <Popup show={!!vehicleId} size="xl">
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle
            headtitle={name}
            subtitle={trans("Connect or link this vehicle to other modules.")}
          />
        </Modal.Title>
        <Close
          // eslint-disable-next-line react/style-prop-object
          style="close-32 close"
          close={() => {
            setIsLinking(false);
          }}
          img="Close"
        />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <GeofencesMultiInput
          label="Geofences"
          styling="mb-3"
          handleLink={handleLink}
          handleUnLink={handleUnLink}
          vehicleId={uniqueId}
          type="vehicles"
        />
        <DriversMultiInput
          label="drivers"
          styling="mb-3"
          handleLink={handleLink}
          handleUnLink={handleUnLink}
          vehicleId={uniqueId}
          userId={inf?.id}
          type="vehicles"
        />
        <NotificationsMultiInput
          label="notifications"
          styling="mb-3"
          handleLink={handleLink}
          handleUnLink={handleUnLink}
          vehicleId={uniqueId}
          userId={inf?.id}
          type="vehicles"
        />
        <MaintenanceMultiInput
          label="Maintenance"
          styling="mb-3"
          handleLink={handleLink}
          handleUnLink={handleUnLink}
          vehicleId={uniqueId}
          type="maintenance"
        />
      </Modal.Body>
    </Popup>
  );
}
